import { UseCasePage } from '@/components/marketing/use-case-page'

export function UseCasesStudentsPage() {
  return (
    <UseCasePage
      contentKey="useCasesStudents"
      path="/use-cases/students"
      relatedKeys={['useCasesResearchers', 'whatIsKnowledgeGraph', 'compareNotebooklm']}
    />
  )
}
